// @module C3.ShoppingExtensions.PLP
define('C3.ShoppingExtensions.PLP.View'
,	[
	'c3_shoppingextensions_plp.tpl'
	
	//,	'C3.ShoppingExtensions.PLP.SS2Model'
	
	,	'Backbone'
    ]
, function (
	c3_shoppingextensions_plp_tpl
	
	//,	PLPSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class C3.ShoppingExtensions.PLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_plp_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new PLPModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return C3.ShoppingExtensions.PLP.View.Context
	,	getContext: function getContext()
		{
			//@class C3.ShoppingExtensions.PLP.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
